"use strict";

require("@patsnap-biz/icon/lib/style/index.scss");

require("./image_preview_dialog.scss");

require("@patsnap-ui/icon/assets/solid/ArrowLeft.svg");

require("@patsnap-ui/icon/assets/solid/ArrowRight.svg");